import { render } from "./TaskCardAccordion.vue?vue&type=template&id=225320bc&scoped=true"
import script from "./TaskCardAccordion.vue?vue&type=script&lang=js"
export * from "./TaskCardAccordion.vue?vue&type=script&lang=js"

import "./TaskCardAccordion.vue?vue&type=style&index=0&id=225320bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225320bc"]])

export default __exports__